<script>
import { Line, mixins } from 'vue-chartjs';
const { reactiveProp } = mixins

export default {
	extends: Line,

    mixins: [reactiveProp],

    data() {
        return {
            options: {
				responsive: true,
				maintainAspectRatio: false,
				tooltips: {
					mode: 'index',
					intersect: false,
				},
				hover: {
					mode: 'nearest',
					intersect: true
				},
				scales: {
					xAxes: [{
						display: false,
						gridlines: {
							display: false
						}
					}],
					yAxes: [{
						display: true,
						scaleLabel: {
							display: true,
							labelString: 'kVA'
						},
						gridlines: {
							display: false
						}

					}]
				}
			}
        }
    },

    mounted() {
        this.renderChart(this.chartData, this.options);
    },
}

</script>